import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { startOfWeek, addDays, subWeeks } from 'date-fns';

export const useRoutineProgress = (weekOffset: number) => {
  const { user } = useAuth();
  const startOfCurrentWeek = startOfWeek(subWeeks(new Date(), weekOffset), { weekStartsOn: 1 });

  return useQuery({
    queryKey: ['routine-progress', weekOffset, user?.id],
    queryFn: async () => {
      if (!user?.id) {
        throw new Error('No user found');
      }

      const startDate = startOfCurrentWeek;
      const endDate = addDays(startDate, 7);

      console.log('Fetching routine progress:', {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        userId: user.id
      });

      const { data, error } = await supabase
        .from('routine_progress')
        .select(`
          id,
          routine_id,
          completed_at,
          exercise_progress,
          routine:routines(
            id,
            name
          )
        `)
        .eq('user_id', user.id)
        .gte('completed_at', startDate.toISOString())
        .lt('completed_at', endDate.toISOString())
        .order('completed_at', { ascending: false });

      if (error) {
        console.error('Error fetching routine progress:', error);
        throw error;
      }

      console.log('Routine progress data:', data);
      return data || [];
    },
    enabled: !!user,
    refetchInterval: false,
    staleTime: 60000,
    gcTime: 300000,
  });
};